import { ReactComponent as SpinnerSVG } from '../../../assets/icons/spinner.svg'

export const Spinner = () => {
  return <SpinnerSVG className='inline mr-2 w-10 h-10 text-gray-200 animate-spin fill-primary-200' />
}
